import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Card,
  CardContent,
  Typography,
  IconButton,
  Box,
  Button,
  Popover,
  Badge,
  Icon,
  CircularProgress,
} from "@mui/material";
import DeleteConfirmationModal from "../deleteConfirmationModal";
import CustomTypography from "../../globalStyles/fonts";
import { isMobile } from "../../globalStyles/mobile";
import { toast } from "react-toastify";
import Pagination from "../pagination";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import ViewIcon from "../../globalStyles/icons/vieewIcon";
import DeleteIcon from "../../globalStyles/icons/deleteIcon";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { historicalShipmentService } from "../../utils/services/historical-shipments.service";
import HistoricalShipmentDetails from "../historical-shipment-modal";
import { roundToThree } from "../../utils/utility";
import UpIcon from "@mui/icons-material/ArrowUpwardOutlined";
import DownIcon from "@mui/icons-material/ArrowDownwardOutlined";
import { useTheme } from "@mui/styles";
import SortingIcon from "../../globalStyles/icons/sorting-icon";
import FilterModal from "../filterModal";

const ActionCell = ({
  order,
  handleViewClick,
  handleEditClick,
  handleDeleteClick,
}) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handlePopoverOpen = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = (e) => {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  const handleActionClick = (action) => {
    handlePopoverClose();
    switch (action) {
      case "view":
        handleViewClick(order);
        break;
      case "edit":
        handleEditClick(order);
        break;
      case "delete":
        handleDeleteClick(order);
        break;
      default:
        break;
    }
  };

  return (
    <Box>
      <IconButton
        aria-label="more actions"
        onClick={handlePopoverOpen}
        sx={{
          color: open ? "primary.main" : "inherit",
        }}
      >
        <MoreVertIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handlePopoverClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            padding: "10px",
          }}
        >
          <Button
            style={{
              color: "var(--text-tertiary)",
              justifyContent: "flex-start",
              textTransform: "none",
            }}
            aria-label="view"
            onClick={(e) => {
              e.stopPropagation();
              handleActionClick("view");
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <ViewIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                color={"var(--text-tertiary)"}
                fontWeight={500}
              >
                View
              </Typography>
            </Box>
          </Button>

          <Button
            style={{
              justifyContent: "flex-start",
              textTransform: "none",
            }}
            aria-label="delete"
            onClick={(e) => {
              e.stopPropagation();
              handleActionClick("delete");
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="flex-start"
              width="100%"
              gap={1}
            >
              <DeleteIcon />
              <Typography
                fontFamily={"poppins"}
                fontSize={"16px"}
                fontWeight={500}
                color={"var(--text-tertiary)"}
              >
                Delete
              </Typography>
            </Box>
          </Button>
        </Box>
      </Popover>
    </Box>
  );
};

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--table-header-bg)",
    padding: "6px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 12,
    padding: "6px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: "var(--bg-paper)",
    border: "1px solid #EAECF0",
  },
  "&:nth-of-type(even)": {
    backgroundColor: "var(--bg-secondary)",
    border: "1px solid #EAECF0",
  },
  "&:lastChild td, &:lastChild th": {
    border: 0,
  },
}));
const HistoricalShipmentList = ({
  viewMode,
  data,
  onEditData,
  onDeleteData,
  setPage,
  setRowsPerPage,
  rowsPerPage,
  page,
  dataCount,
  selectedShipment,
  setSelectedShipment,
  onChangeFilter,
  filterData,
}) => {
  const [historicalShipments, setHistoricalShipments] = useState([]);
  const [openConfirmation, setOpenConfirmation] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [expandedOrderId, setExpandedOrderId] = useState(null);
  const startIndex = rowsPerPage * page;
  const theme = useTheme();
  const defaultColor = "#D13438";
  const primary_color = theme.palette?.primary?.main || defaultColor;
  const [openFilterModal, setOpenFilterModal] = useState(false);
  const [selectedFilterKey, setSelectedFilterKey] = useState("");
  const [anchorElFilter, setAnchorElFilter] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedfilterData, setSelectedFilterData] = useState({
    key: "",
    name: "",
    filter: [],
    sort: 0,
    id: "_id",
    displayKey: "name",
    fetchApi: () => {},
    options: [],
    loadMoreButton: false,
    searchKey: "",
  });

  const handleOpenFilter = (event, filterKey) => {
    setAnchorElFilter(event.currentTarget);
    setSelectedFilterKey(filterKey);
    setOpenFilterModal(true);
    setSelectedFilterData(
      filterData?.columns.find((x) => x?.key === filterKey),
    );
  };

  const handleSaveFilter = (
    selectedOptions,
    filterKey,
    sortOrder,
    searchKey,
  ) => {
    onChangeFilter({
      key: filterKey,
      filter: selectedOptions,
      sort: sortOrder,
      searchKey: searchKey,
    });
    handleCloseFilter();
  };

  const handleCloseFilter = () => {
    setAnchorElFilter(null);
    setOpenFilterModal(false);
  };

  const deleteData = async () => {
    try {
      setLoading(true);
      await historicalShipmentService.delete(selectedShipment.id);
      setOpenConfirmation(false);
      onDeleteData && onDeleteData();
      toast.success("Historical Shipment deleted successfully!");
    } catch (error) {
      toast.error("Failed to delete");
      console.error("Delete failed:", error);
    } finally {
      setLoading(false);
    }
  };
  const handleEditClick = (item) => {
    setSelectedShipment(item);
    onEditData && onEditData(item);
  };
  const handleViewClick = (shipping) => {
    setSelectedShipment(shipping);
    setOpenViewModal(true);
  };
  const handleDeleteClick = (item) => {
    setSelectedShipment(item);
    setOpenConfirmation(true);
  };

  useEffect(() => {
    setHistoricalShipments(
      data?.map((order) => ({
        ...order,
        action: (
          <ActionCell
            order={order}
            handleViewClick={handleViewClick}
            handleDeleteClick={handleDeleteClick}
          />
        ),
      })),
    );
  }, [data]);

  const renderGridView = () => (
    <Grid
      sx={{
        marginTop: "1px",
        maxHeight: "100%",
        paddingBottom: 5,
        overflow: "auto",
      }}
      container
      spacing={2}
    >
      {historicalShipments?.map((x, index) => (
        <Grid
          sx={{ paddingBottom: 1 }}
          item
          xs={12}
          sm={6}
          md={4}
          key={`${x._id} + ${index}`}
        >
          <Card
            sx={{
              boxShadow: 3,
              cursor: "pointer",
              width: "100%",
              height: "100%",
              position: "relative",
              borderRadius: "6px",
              border: "1px solid #D0D5DD",
            }}
          >
            <CardContent>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography
                  fontWeight="500"
                  sx={{ textAlign: "start" }}
                  fontFamily="Poppins"
                  color="var(--text-tertiary)"
                >
                  {startIndex + index + 1}
                </Typography>
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    right: 10,
                  }}
                >
                  {x?.action}
                </div>
              </div>
              <Grid container spacing={1} mt={1}>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="var(--text-tertiary)"
                  >
                    Shipment ID
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    : {x?.shipment_id}
                  </Typography>
                </Grid>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="var(--text-tertiary)"
                  >
                    Shipping Address
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    {x?.shipping_first_name || ""} {x?.shipping_last_name || ""}
                    , {x?.shipping_address1 || ""} {x?.shipping_address2 || ""},{" "}
                    {x?.shipping_city || ""} {x?.shipping_province || ""}{" "}
                    {x?.shipping_country || ""} {x?.shipping_zip || ""}
                  </Typography>
                </Grid>
                <Grid item xs={5} display="flex" alignItems="center">
                  <Typography
                    fontWeight="500"
                    sx={{ textAlign: "start" }}
                    fontFamily="Poppins"
                    color="var(--text-tertiary)"
                  >
                    Dimensions
                  </Typography>
                </Grid>

                <Grid item xs={7}>
                  <Typography
                    noWrap
                    sx={{ textAlign: "start" }}
                    fontWeight="500"
                    fontFamily={"poppins"}
                    color={"var(--text-tertiary)"}
                  >
                    : {x?.height || 0} x {x?.width || 0} x {x?.length || 0}{" "}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );

  const renderListView = () => (
    <div
      style={{
        width: "100%",
        overflow: isMobile() ? "auto" : "hidden",
      }}
    >
      <TableContainer
        sx={{
          overflowY: "auto",
          maxHeight: "100%",
        }}
      >
        <Table stickyHeader aria-label="sticky table">
          <TableHead
            sx={{
              backgroundColor: "var(--table-header-bg) !important",
              "& th": { backgroundColor: "var(--table-header-bg)" },
            }}
          >
            <StyledTableRow>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="var(--text-tertiary)"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  SL NO
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                >
                  {filterData.columns.find((x) => x.key === "shipment_id")
                    ?.sort === 1 ? (
                    <Icon>
                      <UpIcon color="disabled" />
                    </Icon>
                  ) : filterData.columns.find((x) => x.key === "shipment_id")
                      ?.sort === -1 ? (
                    <Icon>
                      <DownIcon color="disabled" />
                    </Icon>
                  ) : null}
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    Shipment ID
                  </Typography>
                  <Badge
                    color="primary"
                    variant="dot"
                    invisible={
                      !filterData?.columns?.find(
                        (item) => item?.key?.toLowerCase() === "shipment_id",
                      )?.filter?.length
                    }
                    overlap="circular"
                  >
                    <IconButton
                      aria-label="filter"
                      size="small"
                      onClick={(event) =>
                        handleOpenFilter(event, "shipment_id")
                      }
                    >
                      <SortingIcon fill={primary_color || "#DC585C"} />
                    </IconButton>
                  </Badge>
                </div>
              </StyledTableCell>
              <StyledTableCell>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                >
                  {filterData.columns.find((x) => x.key === "shipping_zip")
                    ?.sort === 1 ? (
                    <Icon>
                      <UpIcon color="disabled" />
                    </Icon>
                  ) : filterData.columns.find((x) => x.key === "shipping_zip")
                      ?.sort === -1 ? (
                    <Icon>
                      <DownIcon color="disabled" />
                    </Icon>
                  ) : null}
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    Zipcode
                  </Typography>
                  <Badge
                    color="primary"
                    variant="dot"
                    invisible={
                      !filterData?.columns?.find(
                        (item) => item?.key?.toLowerCase() === "shipping_zip",
                      )?.filter?.length
                    }
                    overlap="circular"
                  >
                    <IconButton
                      aria-label="filter"
                      size="small"
                      onClick={(event) =>
                        handleOpenFilter(event, "shipping_zip")
                      }
                    >
                      <SortingIcon fill={primary_color || "#DC585C"} />
                    </IconButton>
                  </Badge>
                </div>
              </StyledTableCell>
              <StyledTableCell>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                >
                  {filterData.columns.find((x) => x.key === "shipping_city")
                    ?.sort === 1 ? (
                    <Icon>
                      <UpIcon color="disabled" />
                    </Icon>
                  ) : filterData.columns.find((x) => x.key === "shipping_city")
                      ?.sort === -1 ? (
                    <Icon>
                      <DownIcon color="disabled" />
                    </Icon>
                  ) : null}
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    City
                  </Typography>
                  <Badge
                    color="primary"
                    variant="dot"
                    invisible={
                      !filterData?.columns?.find(
                        (item) => item?.key?.toLowerCase() === "shipping_city",
                      )?.filter?.length
                    }
                    overlap="circular"
                  >
                    <IconButton
                      aria-label="filter"
                      size="small"
                      onClick={(event) =>
                        handleOpenFilter(event, "shipping_city")
                      }
                    >
                      <SortingIcon fill={primary_color || "#DC585C"} />
                    </IconButton>
                  </Badge>
                </div>
              </StyledTableCell>
              <StyledTableCell>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                >
                  {filterData.columns.find((x) => x.key === "shipping_province")
                    ?.sort === 1 ? (
                    <Icon>
                      <UpIcon color="disabled" />
                    </Icon>
                  ) : filterData.columns.find(
                      (x) => x.key === "shipping_province",
                    )?.sort === -1 ? (
                    <Icon>
                      <DownIcon color="disabled" />
                    </Icon>
                  ) : null}
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    State
                  </Typography>
                  <Badge
                    color="primary"
                    variant="dot"
                    invisible={
                      !filterData?.columns?.find(
                        (item) =>
                          item?.key?.toLowerCase() === "shipping_province",
                      )?.filter?.length
                    }
                    overlap="circular"
                  >
                    <IconButton
                      aria-label="filter"
                      size="small"
                      onClick={(event) =>
                        handleOpenFilter(event, "shipping_province")
                      }
                    >
                      <SortingIcon fill={primary_color || "#DC585C"} />
                    </IconButton>
                  </Badge>
                </div>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="var(--text-tertiary)"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  Dimensions
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="var(--text-tertiary)"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  Dimension Unit
                </Typography>
              </StyledTableCell>
              <StyledTableCell>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "start",
                    alignItems: "center",
                  }}
                >
                  {filterData.columns.find((x) => x.key === "scale_weight")
                    ?.sort === 1 ? (
                    <Icon>
                      <UpIcon color="disabled" />
                    </Icon>
                  ) : filterData.columns.find((x) => x.key === "scale_weight")
                      ?.sort === -1 ? (
                    <Icon>
                      <DownIcon color="disabled" />
                    </Icon>
                  ) : null}
                  <Typography
                    fontSize="14px"
                    color="var(--text-tertiary)"
                    fontWeight={500}
                    fontFamily={"poppins"}
                  >
                    Weight
                  </Typography>
                  {/* <Badge
                    color="primary"
                    variant="dot"
                    invisible={
                      !filterData?.columns?.find(
                        (item) => item?.name?.toLowerCase() === "scale_weight"
                      )?.filter?.length
                    }
                    overlap="circular"
                  >
                    <IconButton
                      aria-label="filter"
                      size="small"
                      onClick={(event) =>
                        handleOpenFilter(event, "scale_weight")
                      }
                    >
                      <SortingIcon fill={primary_color || "#DC585C"} />
                    </IconButton>
                  </Badge> */}
                </div>
              </StyledTableCell>
              <StyledTableCell>
                <Typography
                  fontSize="14px"
                  color="var(--text-tertiary)"
                  fontWeight={500}
                  fontFamily={"poppins"}
                >
                  Weight Unit
                </Typography>
              </StyledTableCell>

              <StyledTableCell>
                <CustomTypography
                  fontSize="14px"
                  title={true}
                  color="var(--text-tertiary)"
                  fontWeight={500}
                ></CustomTypography>
              </StyledTableCell>
            </StyledTableRow>
          </TableHead>
          <TableBody>
            {historicalShipments?.map((x, index) => (
              <React.Fragment key={x.shipment_id + index}>
                <StyledTableRow key={x.shipment_id}>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {startIndex + index + 1}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {x?.shipment_id || ""}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily="Poppins"
                      sx={{ cursor: "pointer" }}
                    >
                      {x?.shipping_zip || ""}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily="Poppins"
                      sx={{ cursor: "pointer" }}
                    >
                      {x?.shipping_city || ""}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily="Poppins"
                      sx={{ cursor: "pointer" }}
                    >
                      {x?.shipping_province || ""}
                    </Typography>
                  </StyledTableCell>

                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily="Poppins"
                      sx={{ cursor: "pointer" }}
                    >
                      {roundToThree(x?.height || 0)} x{" "}
                      {roundToThree(x?.width || 0)} x{" "}
                      {roundToThree(x?.length || 0)}{" "}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {x?.dimension_unit || "--"}
                    </Typography>
                  </StyledTableCell>

                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {roundToThree(x?.scale_weight || 0)}
                    </Typography>
                  </StyledTableCell>
                  <StyledTableCell>
                    <Typography
                      fontSize="12px"
                      color="#667085"
                      fontWeight={400}
                      fontFamily={"Poppins"}
                    >
                      {x?.weight_unit || "--"}
                    </Typography>
                  </StyledTableCell>

                  <StyledTableCell sx={{ width: "3%", textAlign: "center" }}>
                    {x?.action}
                  </StyledTableCell>
                </StyledTableRow>
              </React.Fragment>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );

  return (
    <div sx={{ minWidth: "100%" }}>
      {loading ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
            color: "white",
          }}
        >
          <CircularProgress color="inherit" />
        </Box>
      ) : (
        <div
          style={{
            overflowY: "scroll",
            display: "flex",
            maxHeight: isMobile()
              ? "calc(100vh - 220px)"
              : `calc(100vh - 210px)`,
            width: "100%",
            scrollbarWidth: "none",
            msOverflowStyle: "none",
            "&::WebkitScrollbar": { width: 0 },
          }}
        >
          {viewMode === "grid" || isMobile()
            ? renderGridView()
            : renderListView()}
        </div>
      )}
      <Popover
        open={Boolean(anchorElFilter)}
        anchorEl={anchorElFilter}
        onClose={handleCloseFilter}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableScrollLock={true}
      >
        <FilterModal
          open={openFilterModal}
          onClose={handleCloseFilter}
          options={selectedfilterData?.options}
          selectedValues={selectedfilterData?.filter}
          onSave={handleSaveFilter}
          currentSortOrder={selectedfilterData?.sort}
          filterKey={selectedFilterKey}
          hasMore={selectedfilterData?.loadMoreButton}
          displayKey={selectedfilterData?.displayKey}
          id={selectedfilterData?.id}
          fetchApi={selectedfilterData?.fetchApi}
          searchKey={selectedfilterData?.searchKey}
        />
      </Popover>
      <Pagination
        dataCount={dataCount}
        rowsPerPage={rowsPerPage}
        page={page}
        setPage={setPage}
        setRowsPerPage={setRowsPerPage}
        disableNext={dataCount <= rowsPerPage * (page + 1)}
      />
      <DeleteConfirmationModal
        DeleteConfirmationModal
        title={`Are you sure you want to delete ${selectedShipment?.shipment_id} ?`}
        open={openConfirmation}
        handleClose={() => setOpenConfirmation(false)}
        handleDelete={() => {
          deleteData();
        }}
      />
      <HistoricalShipmentDetails
        shipment={selectedShipment}
        open={openViewModal}
        onClose={() => setOpenViewModal(false)}
      />
    </div>
  );
};

export default HistoricalShipmentList;
